<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.99935 0.667969C4.40435 0.667969 0.666016 4.4063 0.666016 9.0013C0.666016 13.5963 4.40435 17.3346 8.99935 17.3346C13.5943 17.3346 17.3327 13.5963 17.3327 9.0013C17.3327 4.4063 13.5943 0.667969 8.99935 0.667969ZM10.8998 11.7351C10.7777 11.8571 10.6177 11.918 10.4577 11.918C10.2977 11.918 10.1377 11.8571 10.0156 11.7351L7.93227 9.65172C7.81518 9.53422 7.74935 9.37547 7.74935 9.20963V4.6263C7.74935 4.28089 8.02893 4.0013 8.37435 4.0013C8.71977 4.0013 8.99935 4.28089 8.99935 4.6263V8.95088L10.8998 10.8513C11.1435 11.0951 11.1435 11.4909 10.8998 11.7351Z"
            fill="#737370"
        />
    </svg>
</template>
